import {z} from 'zod';

import i18n from '@dms/i18n';

const requiredString = z
  .string({required_error: i18n.t('general.validations.fieldIsRequired')})
  .trim()
  .min(1, i18n.t('general.validations.fieldIsRequired'));

export const EmployeeWorkTeamsFormSchema = z.object({
  branch: requiredString,
  company: requiredString,
  description: requiredString,
});

export type EmployeeWorkTeamsForm = z.infer<typeof EmployeeWorkTeamsFormSchema>;
